import _jsx from "@babel/runtime/helpers/jsx";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { getClassSet, splitBsProps } from './utils/bootstrapUtils';
import createChainedFunction from './utils/createChainedFunction';
import CloseButton from './CloseButton';
import ModalContext from './ModalContext';
function ModalHeader(_ref) {
  let {
    closeLabel = 'Close',
    closeButton = false,
    onHide,
    className,
    children,
    bsClass = 'modal-header',
    ...props
  } = _ref;
  const [bsProps, elementProps] = splitBsProps({
    ...props,
    bsClass
  });
  const classes = getClassSet(bsProps);
  return /*#__PURE__*/_jsx(ModalContext.Consumer, {}, void 0, contextValue => /*#__PURE__*/React.createElement("div", Object.assign({}, elementProps, {
    className: clsx(className, classes)
  }), closeButton && /*#__PURE__*/_jsx(CloseButton, {
    label: closeLabel,
    onClick: createChainedFunction(contextValue && contextValue.onHide, onHide)
  }), children));
}

// TODO: `aria-label` should be `closeLabel`.

export default ModalHeader;